export default __webpack_public_path__ + "static/media/fleets.4679edaa.svg";